import React, { forwardRef } from 'react';
import { BaseLink, useRoute } from 'react-router5';
export const Link = forwardRef((props, ref) => {
    const route = useRoute();
    return <BaseLink ref={ref} {...props} {...route}/>;
});
